@import '../../styles/modals.css';
@import '../../styles/checkout-order-details.css';
@import '../../styles/buttons.css';
@import '../../styles/form.css';

.add-ons-value-wrapper {
  display: flex;
  align-items: flex-start;
}

.stroked-button {
  display: inline-block;
  color: #555;
  border: 1px solid #ccc;
  padding: 3px 11px;
  margin-bottom: 3px;
  border-radius: 15px;
  cursor: pointer;
  transition: background-color .2s;
}

.stroked-button:hover { background: #eaeaea; }

.add-ons-edit-button {
  width: 25px;
  margin-top: 4px;
  cursor: pointer;
}

.add-ons-value {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}

.add-on-chip {
  display: flex;
  align-items: center;
  background: #e1e1e1;
  border: 1px solid #c8c8c8;
  padding: 2px 2px 2px 8px;
  border-radius: 10px;
  margin-right: 6px;
  margin-bottom: 4px;
}

.add-on-chip tambr-icon { 
  width: 16px; 
  height: 16px;
  margin-left: 4px;
  cursor: pointer;
}

.add-on-chip tambr-icon:hover { opacity: 0.9; } 

.add-on-chip span { 
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 150px;
  white-space: nowrap;
}

.notes-text { 
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-right: 1rem;
  word-break: break-word;
}


#payment-method-wrapper {
  position: relative;
  background-color: #f7f7f7;
  border-top: 1px solid #d5d9de;
  display: flex;
  padding: 15px 15px;
}

.payment-method {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
}

.payment-method-label {
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #666;
  padding-right: 10px;
  min-width: 80px;
  font-size: 12px;
  line-height: 18px;
}

.payment-method-value {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.payment-method-edit {
  cursor: pointer;
  width: 25px;
}

.add-payment-method-button {
  background: var(--tambr-accent-color, #000000);
  color: #fff;
  padding: 5px 19px;
  border-radius: 15px;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: .2s background;
}

.add-payment-method-button:hover {
  opacity: 0.8;
}


.order-details {
  border-bottom: 1px solid #d5d9de;
}

tambr-checkout-order-info {
  border-bottom: 1px solid #d5d9de;
}

#payment-form .payment-method {
  display: block;
}

#payment-form .payment-method.hide {
  display: none;
}

#payment-form .card-wrapper {
  margin-top: 10px;
  margin-left: 5px;
}

#payment-form .card-wrapper #card-errors {
  color: #eb1c26;
  margin: 10px 0;
}

#payment-processing {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00000055;
  z-index: 100000000000;
}

.tambr-action-buttons {
  border-top: 1px solid #d5d9de;
}

.timer-wrapper{
  padding-right: 15px;
  text-align: end;
}

.timer-label {
  font-size: 9px;
  text-transform: uppercase;
  color: #777;
  padding-bottom: 3px;
}

.timer {
  font-size: 13px;
}


.terms-checkbox{
  margin-bottom: 10px
}

.terms-checkbox span {
  color: #666;
  letter-spacing: 1px;
}

.terms-checkbox .tambr-clear-button {
  padding: 0;
  text-decoration: underline;
}


.terms-checkbox input {
  vertical-align: middle;
  margin-right: 0.3rem;    
}

.tambr-notification-wrapper {
  padding: 10px 15px;
  background-color: #fff;
  border-bottom: 1px solid #d5d9de;
}

.tambr-notification {
  padding: 5px;
  border-radius: 5px;
  font-weight: 600;
}

.tambr-notification.suspended {
  border: 1px solid #eb1c26;
  background-color: #eb1c2637
}

.tambr-notification.pending_review {
  border: 1px solid #FFA500;
  background-color: #ffa6004f;
}